import request from './request'
import * as http from '@/libs/http'

/**
 * ユーザの同意事項情報を取得する
 *
 * @param {Number} uid ユーザID
 * @returns {Response} レスポンスデータ
 */
export function getUserOptins (uid) {
  return request.get(`/users/${uid}/optins`, {
    validateStatus: (status) => [
      http.OK
    ].includes(status)
  })
}
